import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild, } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as productsActions from "../state/product-list/list-actions";
import * as selectors from "../state/product-list/list-selectors";
/* import * as routerSelectors from "@app/marketplace/route/router.selector"; */
import { MarketProduct } from '../_models/product.interface';
import { BehaviorSubject, fromEvent, Observable, of, Subject, Subscription } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { UrlService } from '@app/services/url.service';
import { isPlatformBrowser } from '@angular/common';
import { ConfigurationPagedSelectorModel } from '@app/marketplace/shared/_models/pagination-selector.model';
import { ConfigurationPagedComponent } from '@app/marketplace/shared/_components/paginator.component';
import * as productSelectors from '../../products/state/product-list/list-selectors';
import * as categorySelectors from '../../categories/state/category/categories-selectors';
import * as categoryTreeSelector from '../../categories/state/category-tree/category-tree-selectors';
import * as searchSelectors from '@app/marketplace/products/state/product-search/search-selectors';
import { _seoContent } from '@app/marketplace/seo-content/utils';
import { debounceTime, delay, distinctUntilChanged, filter, first, switchMap, take, takeUntil } from 'rxjs/operators';
import * as authSelectors from '../../auth/state/auth-selectors';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { CategoryTreeResponse } from '@app/marketplace/categories/_models/category.interface';
import { TreeviewConfig, TreeviewI18n, TreeviewItem } from 'ngx-treeview';
import { CategoryTreeviewI18n } from '@app/marketplace/shared/_components/dropdown-treeview-select/dropdown-treeview-select-sub-category-i18n';
import {animate, style, transition, trigger} from '@angular/animations';
import {ProductService} from '@app/marketplace/products/_services/product.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css'],
  animations: [
    trigger('slowAnimate', [
      transition(':enter', [style({opacity: '0'}), animate(1000)]),
      transition(':leave', [style({opacity: '1'}), animate(1000, style({opacity: '0'}))]),
    ])
  ],
  providers: [{ provide: TreeviewI18n, useClass: CategoryTreeviewI18n }]
})
export class ProductListComponent
  extends ConfigurationPagedComponent<MarketProduct>
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('selectItems', { static: false }) selectItems: ElementRef
  @ViewChild('sortingItems', { static: false }) sortingItems: ElementRef;
  @ViewChild("nav") nav;
  payload: any;
  user$: any;
  provider$: Observable<any>;
  categoryName$: any;
  request$: Observable<any>;
  categoryTree$: Observable<CategoryTreeResponse>;
  loadingCategoryTree$: Observable<boolean>;
  selectCategoryTreeView$ : Observable<TreeviewItem[]>;
  categoriesLocalInfo = _seoContent.map(x => ({ code: x.categoryCode, name: x.sectionId }));
  isBrowser: boolean;
  protected _subscriptions: Subscription[] = [];
  categoryTree: TreeviewItem[] = [new TreeviewItem({ text: '', value: '', checked: false })];
  categoryValues: string[] = [];
  configTree = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 400,
  });
  items = [];
  previousPage: any=1;
  private selectCategorySubject = new BehaviorSubject<boolean>(false);
  stateAnimate: boolean;

  constructor(
    private store: Store<any>,
    private productService: ProductService,
    private urlService: UrlService,
    private metaService: Meta,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId
  ) {
    super(route, metaService, titleService, router, store, platformId,
      new ConfigurationPagedSelectorModel(
        selectors.selectLoading,
        selectors.selectItems,
        selectors.selectPageSize,
        selectors.selectPageNo,
        selectors.selectTotalPage,
        selectors.selectTotalData,
        selectors.selectCount,
        selectors.selectConfiguration
      )
    );
    this.isBrowser = isPlatformBrowser(platformId);
    this.payload = {
      pageIndex: 0,
      pageSize: 12,
      pagingStrategy: 0,
      locationType: 0,
      locations: null,
      locationResolver: false,
      filter: {
        searchTerms: '',
        sortingArgs: 0,
        categories: null,
        priceRange: {
          low: 1,
          high: 1000,
        },
        leafCategories: null
      },
      categoryCode: '',
      supplierCode: '',
      scroll:false
    };
    this.request$ = this.store.select(productSelectors.selectPayload);
    this.categoryTree$ = this.store.select(categoryTreeSelector.selectCategoryTree);
    this.loadingCategoryTree$ = this.store.select(categoryTreeSelector.selectCategoryTreeLoading);
    this.selectCategoryTreeView$ = this.store.select(categoryTreeSelector.selectCategoryTreeView);
    this.user$ = this.store.select(authSelectors.selectUser);
    this.categoryName$ = this.store.select(categorySelectors.selectCategoryName);
    this.provider$ = this.store.select(searchSelectors.selectProvider);
    this.stateAnimate = false;
  }
  loadProducts = (metas = null) => {
    console.log('test');
    if (!this.payload.pageIndex)
      this.payload.pageIndex = 0;
    if (!this.payload.pageSize)
      this.payload.pageIndex = 12;
    if (this.isBrowser) {
      this.store.dispatch(productsActions.LoadingProductsAction({ payload: this.payload }));
    } else {
      this.payload.locationType = 0;
      this.payload.locations = null;
      if (metas) {
        this.payload.categoryCode = metas.categoryCode;
        this.payload.filter.leafCategories = true;
      }
      this.productService.ListProducts(this.payload).subscribe((result: any) => {
        if (result && result.data) {
          result.data.map(data => {
            data.ratingsCounter = new Array(Number(data.rating.toFixed(0)));
          });
          const res = result.data.length < 4 ? result.data.filter(x => x.price > 0 && (x.productProvider != 5 || x.price < 10000)) : result.data.filter(x => x.price > 0 && (x.productProvider != 5 || x.price < 10000)).slice(0, 4);
          this.items$ = new BehaviorSubject(res).asObservable();
          this.productService.countSubject$.next(res.length);
        }
      });
    }

    this.nav?.select(1);
  }
  cancelRequest = () => this.store.dispatch(productsActions.CancelProductRequestAction());
  getSlug = (key: string): string => this.categoriesLocalInfo.find((x) => x.code == key)?.name || key;
  pageChange = ($event: number) => {
    if ($event !== this.previousPage) {
      this.previousPage = $event;
      this.payload.pageIndex = $event;
      //console.info($event);
      this.loadProducts();
    }
  }
  ngOnInit(): void {
    this.title = "Cubatel Market | Compras a Cuba online";
    this.description = "Realiza tus compras para Cuba online desde cualquier lugar del mundo. Entregas a domicilio en toda la Isla. ¡Aprovecha la oportunidad de enviar miles de productos hasta la puerta de tu casa en Cuba!";
    this.keywords = "comprar online en cuba, compras para cuba online";
    this.h1 = "Compra para Cuba online";
    const metas = this.loadPrerender();
    this.payload.filter.categories = null;
    this.payload.pageIndex = 1;
    this.payload.pageSize = 8;
    this.payload.filter.sortingArgs = 0;

    this.loadProducts(metas);
    this.subscriptions.push(this.selectCategorySubject.pipe(debounceTime(300)
    ).subscribe((result) => {if (result == true) {this.loadProducts(); }} ), this.selectCategoryTreeView$.subscribe(items => {
      if (JSON.stringify(this.items.map(x => x.value)) != JSON.stringify(items.map(x => x.value))) {
        this.items = items;
      }
    }));
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      // load products by location
      /*  this._subscriptions.push(this.store.select(locationSelectors.selectLocation).pipe(filter(res => res.isSuccess)).subscribe(() => {
        this.loadProducts();
      })); */
    }
    // load products by category
    /*this._subscriptions.push(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
        this.payload.filter.categories = null;
        this.payload.pageIndex = 1;
        this.payload.pageSize = 12;
        this.payload.filter.sortingArgs = 0;
        this.loadProducts();
      }), this.selectCategorySubject.pipe(debounceTime(300)
      ).subscribe((result) => {if (result == true) {this.loadProducts(); }} ),
      this.selectCategoryTreeView$.subscribe(items => {
        if(JSON.stringify(this.items.map(x => x.value)) != JSON.stringify(items.map(x => x.value))) {
          this.items = items;
        }
      }));*/
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }
   async onScroll() {
    const value = await this.store.pipe(select(selectors.selectCount),take(1)).toPromise();
    if(value<8) return;
    this.payload.pageIndex+=1;
    var payload = {
      pageIndex: this.payload.pageIndex,
      pageSize: 40,
      pagingStrategy: 0,
      locationType: 0,
      locations: null,
      locationResolver: false,
      filter: this.payload,
      categoryCode: '',
      supplierCode: '',
      scroll:true
    };
    console.info(payload);
    this.store.dispatch(productsActions.LoadingProductsAction({ payload}));
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadSelectScript();
      this.loadSortScript();
    }
  }

  loadSelectScript() {
    if (this.selectItems) {
      this._subscriptions.push(fromEvent(this.selectItems.nativeElement, 'change').subscribe(() => {
        this.payload.pageIndex = 1;
        this.payload.pageSize = Number(this.selectItems.nativeElement.value);
        this.loadProducts();
      }));
    } else {
      setTimeout(() => {
        this.loadSelectScript();
      }, 300);
    }
  }

  loadSortScript() {
    if (this.sortingItems) {
      this._subscriptions.push(fromEvent(this.sortingItems.nativeElement, 'change').subscribe(() => {
        this.payload.pageIndex = 1;
        this.payload.filter.sortingArgs = Number(this.sortingItems.nativeElement.value);
        this.loadProducts();
      }));
    } else {
      setTimeout(() => {
        this.loadSortScript();
      }, 300);
    }
  }
  translateFn = (value: number, label: LabelType) => {
    switch (label) {
      case LabelType.Low:
        return "$" + value;
      case LabelType.High:
        return "$" + value;
      default:
        return "$" + value;
    }
  }
  onChangeSlider(event) {
    this.payload.pageIndex = 1;
    this.payload.filter.priceRange = {
      low: event.value,
      high: event.highValue,
    };
    this.loadProducts();
  }

  onSelectCategories(values: string[]) {
    this.categoryValues = values;
    if(values.length > 0) {
      this.payload.filter.categories = values;
    } else {
      this.payload.filter.categories = null;
    }
    this.selectCategorySubject.next(true);
  }

  animate(): void {
    this.stateAnimate = true;
    setTimeout(() => {
      return this.stateAnimate = false;
    }, 2000);
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sb => sb.unsubscribe());
    this.cancelRequest();
  }
}
function firstValueFrom(obs$: any) {
  throw new Error('Function not implemented.');
}

